<template>
  <div>
    <!-- Risk Assessment controls -->
    <b-row
      class="d-flex justify-content-between align-items-center bg-light py-3"
    >
      <b-col md="3">
        <b-form-checkbox
          switch
          size="sm"
          v-model="proposal.steps.riskAssessment.actived"
          >Avaliação de Risco</b-form-checkbox
        >
      </b-col>
      <b-col md="3">
        <b-form-select
          size="sm"
          v-model="proposal.steps.riskAssessment.situation"
          :options="riskAssessmentSituationOptions"
          v-if="proposal.steps.riskAssessment.actived"
          @change="setSitautionNotification"
        ></b-form-select>
      </b-col>
      <b-col md="3">
        <b-form-select
          size="sm"
          v-model="proposal.steps.riskAssessment.status"
          v-if="
            riskAssessmentStatusOptions[proposal.steps.riskAssessment.situation]
          "
          :options="
            riskAssessmentStatusOptions[proposal.steps.riskAssessment.situation]
          "
        ></b-form-select>
      </b-col>
      <b-col md="3">
        <b-form-datepicker
          size="sm"
          placeholder="Data de validade"
          locale="pt-BR"
          :value-as-date="false"
          :date-format-options="{
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          }"
          v-model="proposal.steps.riskAssessment.dueDate"
          v-if="proposal.steps.riskAssessment.status"
        >
        </b-form-datepicker>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col>
        <b-form-group class="mb-0">
          <div class="mb-4"><b>Dados da Operação</b></div>
          <b-row class="d-flex flex-column">
            <b-col>
              <small class="form-text text-muted mb-1"
                >Modalide de Financiamento</small
              >
              <b-form-select
                size="sm"
                v-model="proposal.operationModality"
                :options="optionsOperationModality"
                class="mb-2"
              ></b-form-select>
            </b-col>
            <b-col>
              <small class="form-text text-muted mb-1"
                >Sistema de Amortização</small
              >
              <b-form-select
                size="sm"
                v-model="proposal.amortizationSystem"
                :options="optionsAmortizationSystem"
                class="mb-2"
              ></b-form-select>
            </b-col>
            <b-col>
              <small class="form-text text-muted mb-1">Indexador</small>
              <b-form-select
                size="sm"
                v-model="proposal.indexer"
                :options="optionsIndexer"
                class="mb-2"
              ></b-form-select>
            </b-col>
            <b-col>
              <small class="form-text text-muted mb-1">Prazo Pretendido</small>
              <b-form-input
                size="sm"
                class="mb-2"
                v-model="proposal.period"
                maxlength="3"
              ></b-form-input>
              <b-form-checkbox
                class="mt-1"
                switch
                v-model="proposal.fgts"
                size="sm"
                >Utiliza FGTS?</b-form-checkbox
              >
            </b-col>
          </b-row>
        </b-form-group>
      </b-col>
      <b-col style="border-left: 1px solid #ccc">
        <b-form-group class="mb-0">
          <div class="mb-4"><b>Dados do Imóvel</b></div>
          <b-row class="d-flex flex-column">
            <b-col>
              <small class="form-text text-muted mb-1">Tipo do imóvel</small>
              <b-form-select
                size="sm"
                v-model="proposal.propertyType"
                :options="optionsPropertyType"
                class="mb-2"
              ></b-form-select>
            </b-col>
            <b-col>
              <small class="form-text text-muted mb-1"
                >Categoria do imóvel</small
              >
              <b-form-select
                size="sm"
                v-model="proposal.propertyCategory"
                :options="optionsPropertyCategory"
                class="mb-2"
              ></b-form-select>
            </b-col>
            <b-col>
              <small class="form-text text-muted mb-1"
                >Valor de Compra e Venda</small
              >
              <currency-input
                class="mb-2 form-control form-control-sm"
                maxlength="11"
                v-model="proposal.propertyValue"
                currency="BRL"
                locale="pt"
              />
              <!-- <b-form-input
                    size="sm"
                    class="mb-2"
                    v-model="proposal.propertyValue"
                    v-currency="{currency: 'BRL', locale: 'pt', precision: 2 }"
                    maxlength="16"
                    ></b-form-input>-->
            </b-col>
          </b-row>
        </b-form-group>
      </b-col>
      <b-col style="border-left: 1px solid #ccc">
        <b-form-group class="mb-0">
          <div class="mb-4"><b>Valores da Operação</b></div>
          <b-row class="d-flex flex-column">
            <b-col>
              <small class="form-text text-muted mb-1"
                >Valor de Financiamento Pretendido</small
              >
              <currency-input
                class="mb-2 form-control form-control-sm"
                maxlength="10"
                v-model="proposal.intendedFinancingValue"
                currency="BRL"
                locale="pt"
              />
            </b-col>
            <b-col>
              <small class="form-text text-muted mb-1"
                >Valor de Financiamento Aprovado</small
              >
              <currency-input
                ref="approvedFinancingAmount"
                class="mb-2 form-control form-control-sm"
                maxlength="10"
                v-model="proposal.approvedFinancingAmount"
                currency="BRL"
                locale="pt"
              />
              <b-form-checkbox
                class="mt-1"
                switch
                v-model="proposal.comite"
                size="sm"
                >Comitê</b-form-checkbox
              >
            </b-col>
            <b-col>
              <small class="form-text text-muted mb-1">Valor da Operação</small>
              <currency-input
                ref="operationValue"
                class="form-control form-control-sm"
                maxlength="10"
                v-model="proposal.operationValue"
                currency="BRL"
                locale="pt"
              />
            </b-col>
            <b-col v-if="proposal.notaryExpenses">
              <small class="form-text text-muted mb-1">Valor das Despesas Cartorárias</small>
                  <currency-input
                    ref="notaryExpensesAmount"
                    class="form-control form-control-sm"
                    v-model="proposal.notaryExpensesAmount"
                    currency="BRL"
                    locale="pt"
                    maxlength="9"
                  />
              
            </b-col>
            <b-form-checkbox
                class="mt-2 mx-3"
                switch
                v-model="proposal.notaryExpenses"
                size="sm"
                >Incluir despesas cartorárias</b-form-checkbox
              >
          </b-row>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { CurrencyInput } from "vue-currency-input";
import VueGoogleAutocomplete from "vue-google-autocomplete";

var moment = require("moment");
moment.locale("pt-br");

var bootbox = require("bootbox");

export default {
  name: "ControlOfTheEngineeringFlow",
  data() {
    return {
      array: "",
      riskAssessmentSituationOptions: [
        {
          value: "",
          text: "Selecione a situação",
          color: "light",
          msg: "",
          progress: 0,
        },
        {
          value: "Em análise",
          text: "Em análise",
          color: "secondary",
          msg: "Aguardando análise da documentação em",
          progress: 2,
        },
        {
          value: "Analisado",
          text: "Analisado",
          color: "BadgeColor Aqui",
          msg: "Msg Aqui",
          progress: 0,
        },
      ],
      riskAssessmentStatusOptions: {
        Analisado: [
          {
            value: "",
            text: "Selecione o status",
            color: "light",
            msg: "",
            progress: 0,
          },
          {
            value: "Aprovado",
            text: "Aprovado",
            color: "success",
            msg: "Avaliação de risco aprovada em",
            progress: 30,
          },
          {
            value: "Condicionado",
            text: "Condicionado",
            color: "info",
            msg: "Avaliação de risco condicionada em",
            progress: 30,
          },
          {
            value: "Reprovada",
            text: "Reprovada",
            color: "danger",
            msg: "Avaliação de risco reprovada em",
            progress: 0,
          },
          {
            value: "Com restrição",
            text: "Com restrição",
            color: "warning",
            msg: "Participante(s) com restrição em",
            progress: 5,
          },
          {
            value: "Com pendência(s)",
            text: "Com pendência(s)",
            color: "warning",
            msg: "Proposta apresenta pendência(s) documental em",
            progress: 5,
          },
          {
            value: "Com restrição e Com pendência(s)",
            text: "Com restrição e Com pendência(s)",
            color: "warning",
            msg: "Proposta com pendência(s) e restrição cadastral em",
            progress: 5,
          },
        ],
      },
      pendingList: [
        {
          item: "Matrícula é de inteiro teor",
          subItem:
            "Solicitar matrícula de inteiro teor com ônus reais e/ou ações reipercussórias",
          show: false,
        },
        {
          item: "Matrícula é de ônus reais e/ou ações reipercussórias",
          subItem:
            "Solicitar matrícula de inteiro teor com ônus reais e/ou ações reipercussórias",
          show: false,
        },
        {
          item: "Foi localizado o habite-se",
          subItem:
            "Verifique a necessidade de solicitação do habite-se ou declaração da prefeitura local para comprovação de legalização do imóvel",
          show: false,
        },
        {
          item:
            "Verificado se o imóvel foi adquirido há menos de 3 e se foi ou não utilizado FGTS na aquisição.",
          subItem:
            "Proposta não permite utilização de FGTS. Imóvel adquirido com utlização de FGTS há menos de 3 anos.",
          show: false,
        },
        {
          item:
            "Todos os nomes e CPFs dos vendedores estão averbados corretamente.",
          subItem:
            "Solicite consulta ao jurídico para prosseguir com a averbação concomitante dos dados não localizados.",
          show: false,
        },
      ],
      pendingFgtsList: [
        {
          item: "Autorização de FGTS no App.",
          subItem: "Solicitar autorização do cliente no app do FGTS.",
          notShow: false,
        },
        {
          item: "Extrato analítico.",
          subItem: "Solicitar extrato analítico a agência.",
          notShow: false,
        },
        {
          item: "Possui 36 meses de contribuição ao FGTS?",
          subItem:
            "Conferir se o cliente possuir no mínimo 36 meses de contribuição ao FGTS.",
          notShow: false,
        },
        {
          item: "Cliente não possui imóvel.",
          subItem: "Verifique se o cliente não possui imóvel.",
          notShow: false,
        },
        {
          item: "Declaração de IR com o respectivo recibo de entrega.",
          subItem:
            "Verifique se houve declaração de IR e recebimento do documento.",
          notShow: false,
        },
        {
          item:
            "Imóvel está situação no mesmo município de moradia/trabalho do cliente.",
          subItem:
            "Verifique se o imóvel objeto da operação pertence ao município que o cliente reside ou pretende trabalhar.",
          notShow: false,
        },
      ],
      selectedProposal: this.$store.state.proposalToCheck,
    };
  },
  components: {
    CurrencyInput,
    VueGoogleAutocomplete,
  },
  methods: {
    ...mapActions(["getProposal"]),
    ...mapMutations(["setModificationNotification"]),
    setSitautionNotification(val) {
      if (
        val === "Em análise" && this.selectedProposal.steps.riskAssessment.situation !== val /* && this.selectedProposal.steps.riskAssessment.situation => Se deixar isso a informação não aparece*/
      ) {
        this.setModificationNotification({
          type: "modified",
          created_by: this.user.uid,
          proposalName: this.proposal.name,
          id: this.proposal.id,
          text: "Proposta analisada. Verificar a possibilidade de avaliação.",
        });
      }
    },
  },
  computed: {
    ...mapState([
      "proposal",
      "user",
      "optionsPropertyType",
      "optionsPropertyCategory",
      "optionsAmortizationSystem",
      "optionsIndexer",
      "optionsOperationModality",
    ]),
  },
  watch: {
    "proposal.steps.riskAssessment.situation"(newVal, oldVal) {
      // if (oldVal && newVal !== oldVal) {
      //   this.proposal.steps.riskAssessment.status = "";
      // }
      if (newVal) {
        for (let key in this.riskAssessmentSituationOptions) {
          if (newVal === this.riskAssessmentSituationOptions[key].value) {
            this.proposal.steps.riskAssessment.color = this.riskAssessmentSituationOptions[
              key
            ].color;
            this.proposal.steps.riskAssessment.note = this.riskAssessmentSituationOptions[
              key
            ].msg;
            this.proposal.steps.riskAssessment[
              "progress"
            ] = this.riskAssessmentSituationOptions[key].progress;
          }
        }
      } else {
        this.proposal.steps.riskAssessment.color = "light";
        this.proposal.steps.riskAssessment.note = "";
        this.proposal.steps.riskAssessment.progress = 0;
      }
    },
    "proposal.steps.riskAssessment.status"(newVal) {
      if (newVal) {
        let situationArr = this.riskAssessmentStatusOptions[
          this.proposal.steps.riskAssessment.situation
        ];
        situationArr.forEach((situation) => {
          if (situation.value === newVal) {
            if (situation.color)
              this.proposal.steps.riskAssessment.color = situation.color;
            if (situation.msg)
              this.proposal.steps.riskAssessment.note = situation.msg;
            if (situation.progress)
              this.proposal.steps.riskAssessment.progress = situation.progress;
          }
        });
        if (
          (this.proposal.steps.riskAssessment.status == "Aprovado" &&
            this.proposal.steps.riskAssessment.dueDate == "") ||
          (this.proposal.steps.riskAssessment.status == "Condicionado" &&
            this.proposal.steps.riskAssessment.dueDate == "")
        ) {
          //if ( this.proposal.steps.riskAssessment.status == 'Aprovado' && this.proposal.approvedFinancingAmount == 0 || this.proposal.steps.riskAssessment.status == 'Condicionado' && this.proposal.approvedFinancingAmount == 0 ){
          this.$bvToast.toast(
            `Informe o valor aprovado e confira a data de validade da avaliação. ;)`,
            {
              title: "Eiiii... Lembrando!",
              variant: "primary",
              autoHideDelay: 2000,
            }
          );
          //this.$refs.operationValue.$el.focus();

          var today = new Date();
          var approvalValidity = moment(today)
            .add(180, "days")
            .format("YYYY-MM-DD");
          this.proposal.steps.riskAssessment.dueDate = approvalValidity;
        } //else {
        //var today = new Date();
        //var riskAssessmentDate = moment(today).format('YYYY-MM-DD')
        //this.proposal.steps.riskAssessment.dueDate = riskAssessmentDate;
        //}
      } else {
        for (let key in this.riskAssessmentSituationOptions) {
          if (
            this.proposal.steps.riskAssessment.situation ===
            this.riskAssessmentSituationOptions[key].value
          ) {
            this.proposal.steps.riskAssessment.color = this.riskAssessmentSituationOptions[
              key
            ].color;
            this.proposal.steps.riskAssessment.note = this.riskAssessmentSituationOptions[
              key
            ].msg;
            this.proposal.steps.riskAssessment.progress = this.riskAssessmentSituationOptions[
              key
            ].progress;
          }
        }
      }
    },
    "proposal.steps.riskAssessment.actived"(newVal) {
      if (newVal === false) {
        this.proposal.steps.riskAssessment["badgeColor"] = "light";
        this.proposal.steps.riskAssessment["color"] = "light";
        this.proposal.steps.riskAssessment["dueDate"] = "";
        this.proposal.steps.riskAssessment["note"] = "";
        this.proposal.steps.riskAssessment["situation"] = "";
        this.proposal.steps.riskAssessment["status"] = "";
        this.proposal.steps.riskAssessment["progress"] = 0;
      }
    },
    pendingList: {
      handler: function(val) {
        Vue.set(this.proposal, "pendingList", val);
      },
      deep: true,
    },
    bidderList: {
      handler: function(val) {
        Vue.set(this.proposal, "bidderList", val);
      },
      deep: true,
    },
    pendingFgtsList: {
      handler: function(val) {
        Vue.set(this.proposal, "pendingFgtsList", val);
      },
      deep: true,
    },
    proposal: {
      handler: function(val) {
        if (val.pendingList && val.pendingList.length) {
          this.pendingList = val.pendingList;
        } else if (
          !val.pendingList ||
          (val.pendingList && !val.pendingList.length)
        ) {
          Vue.set(this.proposal, "pendingList", this.pendingList);
        }
        if (val.pendingFgtsList && val.pendingFgtsList.length) {
          this.pendingFgtsList = val.pendingFgtsList;
        } else if (!val.pendingFgtsList) {
          Vue.set(this.proposal, "pendingFgtsList", this.pendingFgtsList);
        }
        if (this.proposal.participants && this.proposal.participants.length) {
          this.proposal.participants.forEach((element) => {
            if (!element.participantList) {
              element.participantList = JSON.parse(
                JSON.stringify(this.participantList)
              );
            }
          });
        }
        if (val.bidderList && val.bidderList.length) {
          this.bidderList = val.bidderList;
        } else if (!val.bidderList) {
          Vue.set(this.proposal, "bidderList", this.bidderList);
        }
      },
      immediate: true,
    },
  },
};
</script>
